import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player";
import cn from "classnames";

import requests from "../../axios/requests";
import { setUser, setUserTrajectory } from "../../../redux/actions/userActions";
import { setConfig, setShowBuyModal, setSelectedDocument, setSelectedTag } from "../../../redux/actions/actions";
import { defaultFuncAndData } from "../../utils/defaultData";
import { Transition } from "react-transition-group";

import { message, Pagination, Spin } from "antd";
import Tag from "../../components/Tag/Tag";
import Button from "../../components/Button/Button";
import PlanningCourse from "./PlanningCourse/PlanningCourse";
import variableLanguage from "../../utils/hooks/hookGetVariablesLanguage";
import ModalBuy from "./Modals/ModalBuy/ModalBuy";
import PrevButton from "../../components/PrevButton/PrevButton";
import ModalSize from "./Modals/ModalSize/ModalSize";
import UnAuthenticated from "./UnAuthenticated/UnAuthenticated";

import { ReactComponent as Arrow } from "../../../images/arrow.svg";
import { ReactComponent as Star } from "../../../images/generate_course/star.svg";
import generation_count from "../../../images/generate_course/generation_count.svg";
import size_icon from "../../../images/generate_course/size_icon.svg";
import size_icon_2 from "../../../images/generate_course/size_icon_2.svg";

import "./GenerateCourse.scss";

const GenerateCourse = () => {
    const variable_1 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_1'});
    const variable_2 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_2'});
    const variable_3 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_3'});
    const variable_4 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_4'});
    const variable_6 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_6'});
    const variable_15 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_15'});
    const variable_17 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_17'});
    const variable_18 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_18'});
    const variable_19 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_19'});
    const variable_21 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_21'});
    const variable_23 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_23'});
    const variable_24 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_24'});
    const variable_25 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_25'});
    const variable_29 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_29'});
    const variable_30 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_30'});
    const variable_32 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_32'});
    const variable_34 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_34'});
    const variable_35 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_35'});
    const variable_36 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_36'});
    const variable_38 = variableLanguage({keyPage: 'generateCourse', keyVariable: 'variable_38'});

    const history = useNavigate();
    const dispatch = useDispatch();
    const {trajectorySkills, user, config, language, showModalBuy, selectedDocument} = useSelector(state => state.Reducer);
    const hasToken = !!localStorage.getItem("token");

    const [page_size, set_page_size] = useState(4);
    const [activePage, setActivePage] = useState(0);
    const [selectTag, setSelectTag] = useState("");
    const [loadingGpt, setLoadingGpt] = useState(false);
    const [currentListEducation, setCurrentListEducation] = useState([]);
    const [allEducationUser, setAlllEducationUser] = useState([]);
    const [openModalSize, setOpenModalSize] = useState(false);
    const [modalSizeIndx, setModalSizeIndx] = useState(null);
    const [currentElemSize, setCurrentElemSize] = useState({});
    const [sizeTrajectory, setSizeTrajectory] = useState(false);
    const [favoritesList, setFavoritesList] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTag, setActiveTag] = useState(null);
    const [curlTrajectory, setCurlTrajectory] = useState(true);
    const [loadingIndx, setLoadingIndx] = useState(null);

    // PDF plan generation state (selectedDocument comes from Redux)
    const [pdfPlansFromDoc, setPdfPlansFromDoc] = useState([]);
    const [loadingDocumentPlan, setLoadingDocumentPlan] = useState(false);
    const [loadingDocumentPlanIndx, setLoadingDocumentPlanIndx] = useState(null);

    // rerender-lazy-state-init: ленивая инициализация, уникальные объекты (не fill с общим reference)
    const [langs, setLangs] = useState(() =>
        Array(4).fill(0).map(() => ({ selected: "RU", list: ["RU", "EN", "SA"], active: false }))
    );
    const setLangsHandler = useCallback((index, value) => {
        setLangs(prev => {
            if (value) return prev.map((el, i) =>
                i === index ? { ...el, active: false, selected: value } : el
            );
            return prev.map((el, i) =>
                i === index ? { ...el, active: true } : el
            );
        });
    }, []);
    // выбор языка для генерации плана по документу

    const getExistTags = useCallback(() => {
        return requests.users.get_plannings()
            .then(res => setAlllEducationUser(res.data.results))
            .catch(() => {});
    }, []);

    const fetchTrajectory = useCallback(() => {
        return requests.auth.get_organization_info()
            .then(res => dispatch(setUserTrajectory(res.data?.planning_skills)))
            .catch(() => {});
    }, [dispatch]);

    const fetchGptApi = useCallback(async () => {
        if (!selectTag?.id) return;
        try {
            const res = await requests.users.fetch_education_plan(selectTag.id);
            setCurrentListEducation(res.data?.results ?? []);
            setLoadingGpt(false);
            setLoadingIndx(null);
        } catch {}
    }, [selectTag?.id, dispatch]);

    const recursyProgress = useCallback((task_id) => {
        setLoadingGpt(true);
        requests.users.calery_progress(task_id)
            .then((res) => {
                const data = res.data;
                if (data.progress.current !== 100) {
                    setTimeout(() => recursyProgress(task_id), 2000);
                } else {
                    fetchGptApi();
                }
            })
            .catch(() => {});
    }, [fetchGptApi]);

    const updateEducationPlan = useCallback(() => {
        if (user?.education_plan_limit === 0) {
            setLoadingGpt(false);
            setLoadingIndx(null);
            return message.error(variable_15);
        }
        requests.users.education_plan({ speciality_tag: selectTag?.id })
            .then((res) => recursyProgress(res.data.task_id))
            .catch(() => {});
    }, [user?.education_plan_limit, selectTag?.id, recursyProgress]);

    const generateQuest = useCallback(async (id) => {
        if (user?.education_plan_limit === 0)
            return message.error(variable_15);
        try {
            const res = await requests.users.generate_quest(id);
            dispatch(setUser({ ...user, education_plan_limit: user.education_plan_limit - 1 }));
            getExistTags();
            setTimeout(() => history(`/backoffice/view-course/${res.data?.quest?.ses}`), 500);
        } catch {
            setLoadingGpt(false);
        }
    }, [user, dispatch, getExistTags, history]);

    const changeFavoritePlan = useCallback((id, value) => {
        requests.users.changeFavoritePlan(id, !value)
            .then(() => {
                setCurrentListEducation(prev => {
                    const newList = [...prev];
                    const indx = newList.findIndex(elem => elem.id === id);
                    if (indx >= 0) newList[indx] = { ...newList[indx], favorite: !value };
                    return newList;
                });
                setPdfPlansFromDoc(prev =>
                    prev.map(p => p.id === id ? { ...p, favorite: !value } : p)
                );
                if (value) {
                    setFavoritesList(prev => ({
                        ...prev,
                        results: prev?.results?.filter(elem => elem.id !== id) ?? [],
                        count: Math.max(0, (prev?.count ?? 1) - 1)
                    }));
                }
                fetchTrajectory();
            })
            .catch(() => {});
    }, [fetchTrajectory]);

    // ─── PDF document plan functions ──────────────────────────────────────

    const fetchDocumentPlan = useCallback(async (docId) => {
        setLoadingDocumentPlan(true);
        setPdfPlansFromDoc([]);
        try {
            const listRes = await requests.users.get_education_plan_pdf_list(docId);
            const raw = listRes.data;
            let planList = Array.isArray(raw)
                ? raw
                : Array.isArray(raw?.results)
                    ? raw.results
                    : raw?.id
                        ? [raw]
                        : [];
            const plansForDoc = planList.filter(
                (p) =>
                    String(p.education_pdf) === String(docId) ||
                    String(p.speciality_pdf) === String(docId) ||
                    String(p.pdf_id) === String(docId)
            );
            setPdfPlansFromDoc(plansForDoc.length > 0 ? plansForDoc : planList);
        } catch {
            // silent: API errors are not surfaced to avoid duplicate messages
        } finally {
            setLoadingDocumentPlan(false);
        }
    }, []);

    // Синхронизация langs при изменении page_size из конфига
    useEffect(() => {
        setLangs(prev => {
            if (prev.length >= page_size) return prev;
            return [...prev, ...Array(page_size - prev.length).fill(0).map(() =>
                ({ selected: "RU", list: ["RU", "EN", "SA"], active: false })
            )];
        });
    }, [page_size]);

    const createDocumentPlan = useCallback(async (indx) => {
        if (!selectedDocument?.id) return;
        if (user?.education_plan_limit === 0) return message.error(variable_15);
        setLoadingDocumentPlanIndx(indx);
        try {
            const language = (langs[indx]?.selected || "RU").toLowerCase();
            const planData = await requests.users.create_education_plan_from_pdf_and_wait(
                selectedDocument.id,
                language
            );
            setPdfPlansFromDoc(prev => [...prev, planData]);
        } catch (err) {
            message.error(
                err.response?.data?.error ||
                err.response?.data?.message ||
                err.message ||
                'Ошибка создания плана'
            );
        } finally {
            setLoadingDocumentPlanIndx(null);
        }
    }, [selectedDocument?.id, user?.education_plan_limit, variable_15, langs]);

    const generateQuestFromUploadedPlan = useCallback(async (planId) => {
        if (user?.education_plan_limit === 0) return message.error(variable_15);
        try {
            const res = await requests.users.generate_quest_pdf(planId);
            dispatch(setUser({ ...user, education_plan_limit: user.education_plan_limit - 1 }));
            setPdfPlansFromDoc(prev =>
                prev.map(p => p.id === planId ? { ...p, quest: res.data?.quest } : p)
            );
            getExistTags();
            setTimeout(() => history(`/backoffice/view-course/${res.data?.quest?.ses}`), 500);
        } catch {
            setLoadingGpt(false);
        }
    }, [user, dispatch, getExistTags, history, variable_15]);

    const fetchFavorites = useCallback(() => {
        return requests.users.fetchFavorites(currentPage, page_size, activeTag)
            .then(({ data }) => setFavoritesList(data))
            .catch(() => {});
    }, [currentPage, page_size, activeTag]);

    const haveFavoriteInList = useCallback((arr) => arr?.some((elem) => elem.favorite) ?? false, []);

    const checkExistTags = useCallback(() =>
        allEducationUser.filter(elem => elem.quest?.id).map((elem) => elem.speciality_tag),
        [allEducationUser]
    );

    useEffect(() => {
        if (window.location.pathname === "/generate-course" && hasToken)
            history("/backoffice/generate-course");

        const configPromise = requests.users.get_config()
            .then(res => {
                dispatch(setConfig(res.data));
                set_page_size(res.data?.PLAN_GENERATION_UPDATE_LIMIT || 4);
            })
            .catch(() => {});

        Promise.all([
            getExistTags(),
            fetchTrajectory(),
            requests.auth.get_profile_new().then(res => dispatch(setUser(res.data))).catch(() => {}),
            configPromise
        ]);
    }, [dispatch, history, hasToken, getExistTags, fetchTrajectory]);

    useEffect(() => {
        if (selectTag) fetchGptApi();
    }, [selectTag, fetchGptApi]);

    useEffect(() => {
        if (activePage === 1) fetchFavorites();
    }, [activePage, currentPage, activeTag, fetchFavorites]);

    useEffect(() => {
        if (selectedDocument?.id) {
            setSelectTag("");
            fetchDocumentPlan(selectedDocument.id);
        } else {
            setPdfPlansFromDoc([]);
            setLoadingDocumentPlan(false);
        }
    }, [selectedDocument?.id, fetchDocumentPlan]);

    return (
        <div
            className={cn("generate_course", {
                not_auth: !hasToken
            })}
        >

            {activePage === 0
                ? <>
                    <div className="group_header">
                        <div
                            className={curlTrajectory
                                ? "header"
                                : "header border_bottom"
                            }>
                            <div className="title_block">
                                <div className="h1">
                                    {variable_1}
                                </div>
                                {hasToken &&
                                    <div className="text">
                                        {variable_2}
                                    </div>
                                }
                            </div>
                            {hasToken
                                ? <div className="header_buttons">
                                    <div
                                        className="favorite"
                                        onClick={() => setActivePage(1)}
                                    >
                                        <Star/>
                                    </div>
                                    <div className="generation_count-block">
                                        {language === "ru"
                                            ? <div className="count">
                                                <span>{user?.education_plan_limit}</span>
                                                <span>{defaultFuncAndData.declension(user?.education_plan_limit, ["Генерация курса", "Генерации курса", "Генераций курса"])}</span>
                                            </div>
                                            : <div>
                                                <span>{user?.education_plan_limit}</span>
                                                <span>Generations course</span>
                                            </div>
                                        }
                                        <div
                                            className="icon"
                                            onClick={() => dispatch(setShowBuyModal(true))}
                                        >
                                            <img src={generation_count} alt="generation_count"/>
                                            <span>{variable_23}</span>
                                        </div>
                                    </div>
                                </div>
                                : <Button
                                    text={variable_36}
                                    click={() => {
                                        history('/backoffice/login')
                                        localStorage.setItem("previous_course_link", "https://edu.skillometer.ru/backoffice/generate-course")
                                    }}
                                    maxWidth={"265px"}
                                />
                            }
                        </div>
                        {localStorage.getItem("token")
                            ? <>
                                <Transition
                                    in={curlTrajectory}
                                    timeout={400}
                                    unmountOnExit
                                    mountOnEnter
                                >
                                    {(state) => (
                                        <div
                                            className={`trajectory_block ${state}`}
                                        >
                                            <div
                                                className={cn("trajectory", {
                                                    open: sizeTrajectory
                                                })
                                                }
                                            >
                                                <div className="top_settings">
                                                    <div className="label">
                                                        {variable_34}
                                                    </div>
                                                    <div
                                                        className="size_btn"
                                                        onClick={() => setSizeTrajectory(!sizeTrajectory)}
                                                    >
                                                    <span>
                                                        {sizeTrajectory ? variable_4 : variable_3}
                                                    </span>
                                                        {sizeTrajectory
                                                            ? <img src={size_icon_2} alt="size_icon"/>
                                                            : <img src={size_icon} alt="size_icon"/>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="info">
                                                    <div className="figure"/>
                                                    <div className="text">{variable_24}</div>
                                                    <div className="figure"/>
                                                    <div className="text">{variable_25}</div>
                                                </div>
                                                {trajectorySkills?.length > 0 &&
                                                    <div className="list_tags">
                                                        {trajectorySkills.map((elem, indx) =>
                                                            <Tag
                                                                elem={elem}
                                                                key={elem.id}
                                                                cursorPointer={true}
                                                                hideRemoveIcon={true}
                                                                countCourses={elem.generated_quests_count}
                                                                countPlanes={elem.education_plans_count}
                                                                className={cn("", {
                                                                    color_active: selectTag?.name === elem.name,
                                                                    exist_quest: checkExistTags().includes(elem.id)
                                                                })}
                                                                exist_quest={checkExistTags().includes(elem.id)}
                                                                click={(event) => {
                                                                    event.stopPropagation();
                                                                    if (loadingIndx === null)
                                                                        setSelectTag(elem)
                                                                    else
                                                                        message.warning(variable_18)
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                }
                                                {trajectorySkills?.length === 0
                                                    ? <Button
                                                        text={variable_19}
                                                        click={() => history("/")}
                                                        margin={"auto 0 0 0"}
                                                        padding={"7px 15px"}
                                                        maxWidth={"100%"}
                                                        backgroundColor={"var(--background_lighten-dark)"}
                                                        boxShadow={"none"}
                                                    />
                                                    : <Button
                                                        text={selectTag?.name ? variable_6 : variable_34}
                                                        click={() => updateEducationPlan()}
                                                        margin={"auto 0 0 0"}
                                                        padding={"7px 15px"}
                                                        maxWidth={"100%"}
                                                        backgroundColor={"var(--background_lighten-dark)"}
                                                        boxShadow={"none"}
                                                        disabled={(!selectTag?.name || loadingGpt || loadingIndx) ||
                                                            (currentListEducation?.length === config?.PLAN_GENERATION_UPDATE_LIMIT)}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    )}
                                </Transition>
                                {loadingGpt &&
                                    <div className="message_loading">
                                        <span>{variable_17}</span>
                                        <Spin/>
                                    </div>
                                }
                                <div
                                    className={curlTrajectory
                                        ? "btn_curl open"
                                        : "btn_curl"
                                    }
                                    onClick={() => setCurlTrajectory(!curlTrajectory)}
                                >
                                    <span>{curlTrajectory ? variable_32 : variable_35}</span>
                                    <Arrow/>
                                </div>
                                {(selectTag || selectedDocument) &&
                                    <div className="title_plan">{variable_38}</div>
                                }

                                {/* PDF document plans */}
                                {selectedDocument && (
                                    <div className="list_planning" data-testid="pdf-plans-section">
                                        {loadingDocumentPlan
                                            ? <div className="message_loading">
                                                <span>{variable_17}</span>
                                                <Spin/>
                                            </div>
                                            : <>
                                                {Array(Number(page_size)).fill(0).map((_, indx) => {
                                                    if (indx > pdfPlansFromDoc.length - 1) {
                                                        return (
                                                            <div
                                                                className="planning_course btn"
                                                                key={`doc-generate-${indx}`}
                                                            >
                                                                <div className="title_index">
                                                                    <div className="h1">
                                                                        <>{variable_21} </>
                                                                        № {indx + 1}
                                                                    </div>
                                                                </div>
                                                                {loadingDocumentPlanIndx === indx
                                                                    ? <div className="message_loading">
                                                                        <span>{variable_17}</span>
                                                                        <Spin/>
                                                                    </div>
                                                                    : <Button
                                                                        text={variable_6}
                                                                        click={() => createDocumentPlan(indx)}
                                                                        padding={"7px 15px"}
                                                                        maxWidth={"fit-content"}
                                                                        boxShadow={"none"}
                                                                        disabled={loadingDocumentPlanIndx !== null}
                                                                        icon={{ position: 'right', name: langs[indx]?.selected }}
                                                                        data-testid={`pdf-slot-btn-${indx}`}
                                                                    />
                                                                }
                                                                <div className={langs[indx]?.active ? "lang_changer open" : "lang_changer"}>
                                                                    {langs[indx]?.active
                                                                        ? <>{langs[indx].list.map(el => <div key={el} onClick={() => setLangsHandler(indx, el)}>{el}</div>)}</>
                                                                        : <div onClick={() => setLangsHandler(indx)}>{langs[indx]?.selected}</div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    const plan = pdfPlansFromDoc[indx];
                                                    return (
                                                        <PlanningCourse
                                                            {...plan}
                                                            key={`pdf-plan-${plan.id}`}
                                                            indx={indx}
                                                            isUploadedDocument={true}
                                                            changeFavoritePlan={changeFavoritePlan}
                                                            generateQuest={generateQuestFromUploadedPlan}
                                                            openModalSize={() => {
                                                                setOpenModalSize(true);
                                                                setModalSizeIndx(indx);
                                                                setCurrentElemSize({ ...plan, isUploadedDocument: true });
                                                            }}
                                                            loadingIndx={loadingDocumentPlanIndx}
                                                            fullWidth={pdfPlansFromDoc.length === 1}
                                                        />
                                                    );
                                                })}
                                            </>
                                        }
                                    </div>
                                )}

                                {/* Tag-based plans */}
                                {selectTag && (
                                    <div className="list_planning">
                                        <>
                                            {Array(Number(page_size)).fill(0).map((_, indx) => {
                                                if ((indx > currentListEducation.length - 1) && selectTag.name) {
                                                    return (
                                                        <div
                                                            className="planning_course btn"
                                                            key={`generate-${indx}`}
                                                        >
                                                            <div className="title_index">
                                                                <div className="h1">
                                                                    <>{variable_21} </>
                                                                    № {indx + 1}
                                                                </div>
                                                            </div>
                                                            {loadingIndx === indx
                                                                ? <>
                                                                    <div className="message_loading">
                                                                        <span>{variable_17}</span>
                                                                        <Spin/>
                                                                    </div>
                                                                </>
                                                                : <Button
                                                                    text={variable_6}
                                                                    click={() => {
                                                                        setLoadingIndx(indx)
                                                                        updateEducationPlan()
                                                                    }}
                                                                    padding={"7px 15px"}
                                                                    maxWidth={"fit-content"}
                                                                    boxShadow={"none"}
                                                                    disabled={loadingIndx !== null}
                                                                />
                                                            }
                                                        </div>
                                                    )
                                                }
                                                if (currentListEducation[indx])
                                                    return (
                                                        <PlanningCourse
                                                            {...currentListEducation[indx]}
                                                            key={`planning-${currentListEducation[indx].id}`}
                                                            indx={indx}
                                                            changeFavoritePlan={changeFavoritePlan}
                                                            generateQuest={generateQuest}
                                                            openModalSize={() => {
                                                                setOpenModalSize(true);
                                                                setModalSizeIndx(indx);
                                                                setCurrentElemSize(currentListEducation[indx])
                                                            }}
                                                            loadingIndx={loadingIndx}
                                                            fullWidth={currentListEducation.length === 1}
                                                        />
                                                    )
                                            }
                                            )}
                                        </>
                                    </div>
                                )}

                                {!selectTag && !selectedDocument &&
                                    <div className="player_auth">
                                        <ReactPlayer
                                            className={"player_demo"}
                                            controls={true}
                                            url={"https://www.youtube.com/watch?v=VuCj68f6pUQ"}
                                            width={"100%"}
                                        />
                                    </div>
                                }
                            </>
                            : <UnAuthenticated
                                curlTrajectory={curlTrajectory}
                                sizeTrajectory={sizeTrajectory}
                                trajectorySkills={trajectorySkills}
                                setSizeTrajectory={setSizeTrajectory}
                            />
                        }
                    </div>
                </>
                : <div className="favorite_page">
                    <PrevButton click={() => setActivePage(0)}/>
                    <div className="header">
                        <div className="title_block">
                            <div className="h1">
                                {variable_29}
                            </div>
                            <div className="text">
                                {variable_30}
                            </div>
                        </div>
                    </div>
                    {(trajectorySkills.length > 0 && haveFavoriteInList(trajectorySkills)) &&
                        <div className="parent_traektory">
                            <div className="traektory">
                                {trajectorySkills.map((elem) => {
                                        if (elem.education_plans_count > 0 && elem.favorite)
                                            return (
                                                <Tag
                                                    key={elem.id}
                                                    elem={elem}
                                                    border={activeTag === elem.id}
                                                    cursorPointer={true}
                                                    hideRemoveIcon={true}
                                                    click={() => {
                                                        if (activeTag === elem.id) {
                                                            setActiveTag(null)
                                                        } else setActiveTag(elem.id)
                                                    }}
                                                />
                                            )
                                    }
                                )}
                            </div>
                        </div>
                    }
                    {(favoritesList?.results?.length > 0 && !loadingGpt) &&
                        <div className="list_planning">
                            <>
                                {favoritesList.results.map((elem, indx) =>
                                    <PlanningCourse
                                        {...elem}
                                        key={`planning-${elem.id}`}
                                        indx={indx}
                                        changeFavoritePlan={(id, value) => {
                                            changeFavoritePlan(id, value);
                                            fetchTrajectory()
                                            fetchFavorites()
                                        }}
                                        generateQuest={generateQuest}
                                        isFavorite={true}
                                    />
                                )}
                            </>
                        </div>
                    }
                    {(favoritesList?.count > page_size) &&
                        <div className="pagination_all">
                            <Pagination
                                itemRender={defaultFuncAndData.itemRenderPagination}
                                current={currentPage}
                                defaultCurrent={1}
                                defaultPageSize={page_size}
                                total={favoritesList.count}
                                onChange={(e) => setCurrentPage(e)}
                                showTitle={false}
                            />
                        </div>
                    }
                </div>
            }

            {/*  <ModalInvite
                openModalInvite={openModalInvite}
                setOpenModalInvite={setOpenModalInvite}
                currentElemSize={currentElemSize}
            />*/}
            <ModalSize
                openModalSize={openModalSize}
                currentElemSize={currentElemSize}
                changeFavoritePlan={changeFavoritePlan}
                generateQuest={
                    currentElemSize?.isUploadedDocument
                        ? generateQuestFromUploadedPlan
                        : generateQuest
                }
                indx={modalSizeIndx}
                loadingIndx={loadingIndx}
                setOpenModalSize={() => {
                    setOpenModalSize(false)
                    setModalSizeIndx(null)
                    setCurrentElemSize({})
                }}
            />
            <ModalBuy
                openModalBuy={showModalBuy}
                setOpenModalBuy={(value) => dispatch(setShowBuyModal(value))}
                config={config}
            />
        </div>
    )
}

export default GenerateCourse;